import { hasCookie } from './cookie';
import { getPortalId } from './get-portal-id';
export const hasAppAuth = () => {
  return /hubspot(qa)?\.com$/.test(window.location.hostname) && hasCookie('csrf.app') && Boolean(getPortalId());
};